type ExecutionStatusBadgeProps = {
  status: string;
  showAsRunning?: boolean;
};

export function ExecutionStatusBadge({ status, showAsRunning = false }: ExecutionStatusBadgeProps) {
  const displayStatus = showAsRunning && status.toLowerCase() === 'pending' ? 'Running' : status;

  const getStatusColor = () => {
    const lowerStatus = status.toLowerCase();
    if (lowerStatus === 'completed') {
      return { color: '#065f46', backgroundColor: '#d1fae5' };
    } else if (lowerStatus === 'pending' || lowerStatus === 'running') {
      return { color: '#92400e', backgroundColor: '#fef3c7' };
    } else {
      return { color: '#991b1b', backgroundColor: '#fee2e2' };
    }
  };

  const { color, backgroundColor } = getStatusColor();

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 500,
        color,
        backgroundColor,
      }}
    >
      {displayStatus}
    </span>
  );
}
